module.exports = __webpack_public_path__ + "1793882494189/images/logo_light.bbd6e65.png";